import Layout from '@/layouts'
import {i18n} from "@/utils/i18n";

const schedule = {
  path: '/hospital',
  component: Layout,
  name: 'hospital',
  redirect: '/hospital/index',
  children: [{
    path: '/hospital/index',
    component: () => import('@/views/hospital/index'),
    name: 'hospital.index',
    meta: {
      title: i18n.t(`message.hospital`)
    }
  }]
}

export default schedule